<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeProduitAchatLoc.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(permCatalogue.maj) ?
                      $router.push({ name: 'm.bodac.catalogue-nouveauLocation',
                      params: { isFromCatalogueAchat: true } }) : showPopUp()"
                      :class="[{ 'button-access-no-permission' :
                      !checkPermissions(permCatalogue.maj) || !canCreateProduct },
                      { 'pointer-events-none' : !canCreateProduct }]">
                {{ $t('listeProduitAchatLoc.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="inProgress()"
              :options='[]'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllProduitSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeProduitAchatLoc.actions.search')"
                     type="search"
                     v-model="criteresRecherche.auto"
                     icon="magnify">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permCatalogue.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row">
        </b-checkbox>
      </div>
      <div slot="reference" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.catalogue-location',
        params: { id: props.row.id, isFromCatalogueAchat: true }}" class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permCatalogue.lecture)}">
          {{ props.row.reference }}
        </router-link>
      </div>
      <div slot="societe" slot-scope="props">
        <div>{{ getLibelleSociete(props.row.supportCommercial.societeId) }}</div>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ getLibelleActif(props.row.actif) }}</div>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link :to="{ name: 'm.bodac.catalogue-editionLocation',
           params: { produitId: props.row.id, isFromCatalogueAchat: true } }"
                     :class="{'disabled': isModifiableIntoHolding(props.row)}">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permCatalogue.maj)
          || isModifiableIntoHolding(props.row)}"></b-icon>
        </router-link>
      </div>
      <div slot="archiver" slot-scope="props">
        <div @click="checkPermissions(permCatalogue.supprimer) ? openPopUpArchivage(props.row) :
            showPopUp()" class="is-cursor-pointer"
             :class="{'disabled': isModifiableIntoHolding(props.row)}">
          <b-icon type="is-default" :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permCatalogue.supprimer)
          || isModifiableIntoHolding(props.row)}">
          </b-icon>
        </div>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(permCatalogue.supprimer) ? inProgress() :
            showPopUp()" :class="{'disabled': isModifiableIntoHolding(props.row)}"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(permCatalogue.supprimer)
                      || isModifiableIntoHolding(props.row) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-produit-achat-loc ref="filtreListeProduitAchatLoc"
                                        @toggleFiltre="setShowFiltre"
                                        @recherche="makeRechercheFilter()"
        />
      </div>
    </transition>
    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal" @close="produitToArchive = null">
      <pop-up-archivage v-if="produitToArchive"
             :messHeader="$t(produitToArchive.actif ? 'listeProduitAchatLoc.archivage.archiver'
             : 'listeProduitAchatLoc.archivage.desarchiver')"
             :cancel="$t('listeProduitAchatLoc.archivage.no')"
             :validate="$t('listeProduitAchatLoc.archivage.yes')"
             @no="popUpArchivage = false"
             @yes="archiverProduit()"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import breadcrumb from '@/components/general/breadcrumb';
import selecteurAction from '@/components/general/selecteurAction';
import inProgress from '@/services/general/inProgress';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import messageErreur from '@/services/general/messageErreur';
import { SENS_ACHAT } from '@/configuration/devisConf';
import filtreListeProduitAchatLoc from '@/components/baux/produitsAchat/filtreListeProduitAchats';
import { archiver } from '@/api/produit/produitLocation';
import messageSucces from '@/services/general/messageSucces';
import popUpArchivage from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { getIdSocieteHolding, siteHasHolding } from '@/services/general/holding';
import { columnsSplice } from '@/services/general/columns';
import * as produitConf from '@/configuration/catalogue/produitConf';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_PRODUITS_ACHATS } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const ProduitLocation = createNamespacedHelpers('produitLocationAchat');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      showFiltre: false,
      permCatalogue: CATALOGUE,
      actions: [
        { action: ACTION_DELETE, translation: 'listeProduitAchatLoc.actions.delete' },
      ],
      produitToArchive: null,
      popUpArchivage: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_LISTE_PRODUITS_ACHATS,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    TableItemsInView,
    filtreListeProduitAchatLoc,
    popUpArchivage,
    exportExcelButton,
    parametrageTable,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      lockMenu: 'lockMenu',
      societeActiveId: 'societeActiveId',
    }),
    ...ProduitLocation.mapGetters({
      produits: 'produits',
      totalProduits: 'totalProduits',
      criteresRecherche: 'criteresRecherche',
    }),
    canCreateProduct() {
      return (!siteHasHolding()
        || (siteHasHolding() && this.societeActiveId === getIdSocieteHolding()));
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeProduitAchatLoc.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitAchatLoc.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      nombreCritere += this.criteresRecherche.societeId ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    iconSelectTotal() {
      if (this.allProduitSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allProduitSelected() {
      return this.getAllProduitSelected().length === this.produits.length
        && this.produits.length > 0;
    },
    columns() {
      const columns = ['selected', 'reference', 'libelle', 'schemaComptable.libelle', 'societe', 'actif', 'edit', 'archiver', 'delete'];
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete) {
        columnsSplice(columns, 'societe');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitAchatLoc.tabs.reference'),
          libelle: this.$i18n.t('listeProduitAchatLoc.tabs.libelle'),
          societe: this.$i18n.t('listeProduitAchatLoc.tabs.societe'),
          'schemaComptable.libelle': this.$i18n.t('listeProduitAchatLoc.tabs.schemaComptable'),
          actif: this.$i18n.t('listeProduitAchatLoc.tabs.actif'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['reference', 'libelle', 'actif'],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.sens = SENS_ACHAT;
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...ProduitLocation.mapActions({
      loadProduits: 'loadProduits',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    isModifiableIntoHolding(produit) {
      return siteHasHolding() && (((produit.supportCommercial.societeId !== getIdSocieteHolding()
        || produit.supportCommercial.societeId !== this.societeActiveId)
        && (produit.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION
          || produit.supportCommercial.categorieVente === produitConf.CATEGORIE_DIVERS)))
        || (produit.supportCommercial.societeId !== this.societeActiveId
          && produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_LOCATION
          && produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_DIVERS);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduitAchatLoc.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeProduitAchatLoc.initializeFiltre();
      this.$refs.filtreListeProduitAchatLoc.viderCritere();
      this.$refs.filtreListeProduitAchatLoc.appliquerCritere();
      this.showFiltre = false;
    },
    async archiverProduit() {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produitToArchive.id, this.produitToArchive.actif);
        messageSucces(this.$i18n.t(this.produitToArchive.actif
          ? 'listeProduitAchatLoc.archivage.sucessArchivage'
          : 'listeProduitAchatLoc.archivage.successDesarchivage'));
        loadingComponent.close();
        this.produitToArchive = null;
        this.recherche();
      } catch (e) {
        this.produitToArchive = null;
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    openPopUpArchivage(produit) {
      this.produitToArchive = produit;
      this.popUpArchivage = true;
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getAllProduitSelected() {
      return this.produits.filter((el) => {
        return el.selected;
      });
    },
    handleAction(action) {
      if (action === ACTION_DELETE) {
        if (this.checkPermissions(this.permCatalogue.supprimer)) this.inProgress();
        else this.showPopUp();
      }
    },
    selectAll() {
      const select = !this.allProduitSelected;
      this.produits.forEach((el) => {
        el.selected = select;
      });
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    if (this.filtrerProduitParSociete) {
      this.unsubscribeValue();
    }
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSocietes({});
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key]);
      if (this.filtrerProduitParSociete) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      }
      this.setInformationPage(this.$t('pageBaux.produitAchatLoc.liste'));
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
